module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAxMiAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTEwLjE5MDUgMjMuNzhMMS4wMzkzNmUtMDYgMTEuODkxMUwxMC4xOTA1IDAuMDAyMjUyNDJMMTIgMS41NTc4MUwzLjE0Mjg2IDExLjg5MTFMMTIgMjIuMjI0NUwxMC4xOTA1IDIzLjc4WiIgZmlsbD0iIzJEMkQyRCIvPgo8L3N2Zz4K"


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon/btn_arrow.svg
// module id = 4GGL
// module chunks = 1